import React from 'react';

const ShipmentStatusCards = ({ statusCounts }) => {
  const statusConfig = {
    pending: { label: 'En préparation', color: 'blue' },
    in_transit: { label: 'En transit', color: 'purple' },
    customs: { label: 'En douane', color: 'yellow' },
    out_for_delivery: { label: 'En livraison', color: 'indigo' },
    delivered: { label: 'Livrés', color: 'green' },
    exception: { label: 'Problème', color: 'red' }
  };

  const colorClasses = {
    blue: 'bg-blue-50 border-blue-200 text-blue-900',
    purple: 'bg-purple-50 border-purple-200 text-purple-900',
    yellow: 'bg-yellow-50 border-yellow-200 text-yellow-900',
    indigo: 'bg-indigo-50 border-indigo-200 text-indigo-900',
    green: 'bg-green-50 border-green-200 text-green-900',
    red: 'bg-red-50 border-red-200 text-red-900'
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Statuts des envois</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {Object.entries(statusConfig)?.map(([key, config]) => (
          <div
            key={key}
            className={`rounded-lg border p-4 ${colorClasses?.[config?.color]}`}
          >
            <p className="text-sm font-medium mb-1">{config?.label}</p>
            <p className="text-2xl font-bold">{statusCounts?.[key] || 0}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShipmentStatusCards;